module.exports = __webpack_public_path__ + "static/img/lable.07f16e1.png";